













declare let echarts: any;
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
@Component({
    name: "RememberStatisticsDashboard",
})
export default class RememberStatisticsDashboard extends Vue {
    @Provide() private txt: any = this.$t;
    @Provide() private legend: any = '';
    @Provide() private chartData: any = ['0', '0', '0', '40', '50', '15', '25', '35', '25.7', '52.1', '45.4', '35.7', '65.3', '56', '58', '59.6', '65.3', '59.3', '66.4', '35.3','75.3','25.3','35.6','15.3' ];
    @Provide() private chartDateList: any = [];
    @Provide() private chartValueList: any = [];
    @Provide() private chartDetailList: any = [];
    private created() {
      this.chartDateList = JSON.parse(decodeURIComponent((this.$route.query.list as any))).map((item: any) => (item.hour))
      this.chartData = JSON.parse(decodeURIComponent((this.$route.query.list as any))).map((item: any) => (item.answerrate))
      this.chartDetailList = JSON.parse(decodeURIComponent((this.$route.query.list as any))).map((item: any) => (item.detail))
      this.chartValueList = [0, 25, 50, 100, 125];
      this.legend = this.$route.query.title;
    }
    private mounted() {
        this.createCharts();
    }
    private createCharts() {
        const ele = document.getElementById("staticsTable");
        const chart: any = echarts.init(ele);
        let _chart_one = this.legend;
        let options: any = {
            tooltip: {
                trigger: "axis",
                formatter: (param: any) => {
                  return `${param[0].data}%(${this.chartDetailList[param[0].dataIndex]})`;
                }
            },
            legend: {
                data: [{
                    name: _chart_one,
                    icon: 'none'
                  }
                ]
            },
            grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: 'save as picture',
                        type: 'png'
                    },
                }
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: this.chartDateList,
                splitLine: {
                    show: false
                },
            },
            yAxis: {
                type: "value",
                min: 0,
                max: 120,
                internal: 25,
                splitNumber: 5,
                boundaryGap: false,
                nameTextStyle: {
                  fontWeight: 'bold'
                },
                splitLine: {
                  show: true
                },
                axisLabel: {
                  fontWeight: 'bold',
                  fontSize: 16,
                  borderColor: 'lightgreen'
                }
                // data: this.chartValueList
            },
            series: [
                {
                    name: _chart_one,
                    type: 'line',
                    smooth: true,
                    data: this.chartData,
                    itemStyle: {
                        color: 'lightblue',
                        borderWidth: 1,
                        borderType: [5, 18],
                        borderDashOffset: 6
                    },
                    lineStyle: {
                        color: 'rgb(10, 96, 171)',
                        width: 5,
                        shadowColor: 'rgba(173, 216, 230, 0.4)',
                        shadowBlur: 3
                    },
                    label: {
                      show: true,
                      fontWeight: 'bold',
                      fontSize: 10,
                      color: 'rgba(60, 210, 80, 0.7)',
                      formatter: (param: any) => {
                        return `${param.data}%(${this.chartDetailList[param.dataIndex]})`;
                      }
                    }
                }
            ]
        };
        chart.setOption(options);
    }
    private testCharts() {
        var chartDom = document.getElementById('staticsTable');
        var myChart = echarts.init(chartDom);
        var option;

        var dateList = this.chartDateList;
        var valueList = this.chartValueList;

        option = {

            // Make gradient line here
            visualMap: [{
                show: false,
                type: 'continuous',
                seriesIndex: 0,
                min: 0,
                max: 400
            }],


            title: [{
                left: 'center',
                text: 'Gradient along the y axis'
            }],
            tooltip: {
                trigger: 'axis'
            },
            xAxis: [{
                data: dateList
            }],
            yAxis: [{
              data: valueList
            },],
            grid: [{
                bottom: '60%'
            }],
            series: [{
                type: 'line',
                showSymbol: false,
                itemStyle: {
                    borderWidth: 1,
                    borderType: [5, 18],
                    borderDashOffset: 6
                },
                data: this.chartData
            }]
        };

        option && myChart.setOption(option);

    }
}
